import request from '@/request'
export function register(signUpType, typeCode, phone, email, dialCode, verificationCode, password,account) {
  const data = {
    signUpType,
    typeCode,
    phone,
    email,
    dialCode,
    verificationCode,
    password,
    account
  }
  return request({
    url: '/register',
    method: 'post',
    data
  })
}

export function login(account, password, email, phone, verificationCode, loginType) {
  const data = {
    account,
    password,
    email,
    phone,
    verificationCode,
    loginType
  }
  return request({
    url: '/login',
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: '/logout',
    method: 'get'
  })
}

export function getUserInfo() {
  return request({
    url: '/user/current',
    method: 'get'
  })
}

export function sendLoginEmailCode(email) {
  return request({
    url: `/sendLoginEmailCode?email=${email}`,
    method: 'get'
  })
}

export function sendLoginPhoneCode(phone, lang) {
  return request({
    url: `/sendLoginPhoneCode?phone=${phone}&lang=${lang}`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js